
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/authSlice/authSlice';
import budgetReducer from "../redux/budgetSlice/budgetSlice";
import packageReducer from "../redux/packageSlice/packageSlice";
import unitReducer from "../redux/unitSlice/unitSlice";
import operatingReducer from "../redux/operatingSlice/operatingSlice";
import otherProjectsReducer from '../redux/otherProjectsSlice/otherProjectsSlice';
import guidelineReducer from '../redux/guidelineSlice/guidelineSlice';
import projectReducer from '../redux/projectsSlice/projectSlice';
import productReducer from '../redux/productSlice/productSlice';
import unitReportReducer from '../redux/adminUnitReportSlice/adminUnitReportSlice';
import dashboardReducer from '../redux/dashboardSlice/dashboardSlice';
import internalOrderMasterReducer from '../redux/internalOrderSlice/internalOrderSlice';
import adminCacheReducer from '../redux/adminCacheSlice/adminCacheSlice';
import masterUploadsReducer from '../redux/masterUploadsSlice/masterUploadsSlice';

const store = configureStore({
        reducer: {
                auth: authReducer,
                budget: budgetReducer,
                package: packageReducer,
                product: productReducer,
                unit: unitReducer,
                operating: operatingReducer,
                otherProjects: otherProjectsReducer,
                guideline: guidelineReducer,
                project: projectReducer,
                unitReport:unitReportReducer,
                project: projectReducer,
                dashboard: dashboardReducer,
                internalOrderMaster: internalOrderMasterReducer,
                masterUploads: masterUploadsReducer,
        },
});

export default store;
